import {
  API_ENDPOINT,
  useClientApiV1AuthPhoneVerificationCheckCreateMutation,
} from '../../resources/@types/accountSchema';

function useClientAuthPhoneVerificationCheckCreateMutation(
  options?: Parameters<typeof useClientApiV1AuthPhoneVerificationCheckCreateMutation>[0]['options'],
) {
  return useClientApiV1AuthPhoneVerificationCheckCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_AUTH_PHONE_VERIFICATION_CHECK,
    options,
  });
}

export default useClientAuthPhoneVerificationCheckCreateMutation;
